import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from './incentiveUpdateTypes'
import API from './incentiveUpdateApis'

function* watchFetchIncentiveUpdateReasons() {
  try {
    const response = yield call(API.fetchIncentiveUpdateReasons)
    if (response.status === 200) {
      yield put({type: types.FETCH_INCENTIVE_UPDATE_REASONS_SUCCEEDED, payload: response.data})
    }
  } catch (err) {
    yield put({type: types.FETCH_INCENTIVE_UPDATE_REASONS_FAILED, err})
  }
}

function* watchUpdateIncentive(action) {
  try {
    const response = yield call(API.updateIncentive, action.payload)
    if (response.status === 200) {
      yield put({type: types.UPDATE_INCENTIVE_SUCCEEDED, payload: response.data})
      yield put({type: 'SHOW_MESSAGE', payload: {message: 'Reward Updated Successfully.', className: 'copy-screeners-snackbar'}})
      yield put({type: 'HIDE_MESSAGE'})
    }
  } catch (err) {
    yield put({type: types.UPDATE_INCENTIVE_FAILED, err})
    yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again',  className: 'error-snackbar'}})
    yield put({type: 'HIDE_MESSAGE'})
  }
}

export default function* () {
  yield takeLatest(types.FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED, watchFetchIncentiveUpdateReasons)
  yield takeLatest(types.UPDATE_INCENTIVE_REQUESTED, watchUpdateIncentive)
}